<template>
    <div class="questions-answers">
        <aside class="questions-answers__wrap">
            <nav class="questions-answers__menu">
                <ul class="questions-answers__menu-list">
                    <router-link class="questions-answers__menu-item"
                            v-for="item in itemsMenu"
                            v-bind:class="'questions-answers__menu-item--'+item.name"
                            @click.native="scroll(item)"
                            :key="item.id"
                            :to="{ name: 'QuestionType',
                            params: {
                                questionName: item.name,
                                questionText: item.text,
                                questionImage: item.image
                            }
                        }">
                        <img class="questions-answers__item-icon" :src="item.image" alt="" />
                        <span class="questions-answers__item-description" v-html="item.text"></span>
                    </router-link>
                </ul>
            </nav>
        </aside>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
</template>
<script>
import widthMixin from '@/modules/mixins/widthMixin';

export default {
	name: "QuestionsAnswers",
	mixins: [widthMixin],
	data(){
		return {
			itemsMenu: [
				{
					name: 'often-asked',
					image: require('@/assets/svg/icons/question_answers/icon_star.svg'),
					text: 'Часто спрашивают',
				},
				{
					name: 'o-micro',
					image: require('@/assets/svg/icons/question_answers/icon_info.svg'),
					text: 'О Микро',
				},
				{
					name: 'credit-terms',
					image: require('@/assets/svg/icons/question_answers/icon_doc.svg'),
					text: 'Условия микрокредита',
				},
				{
					name: 'get-loan',
					image: require('@/assets/svg/icons/question_answers/icon_man_question.svg'),
					text: 'Получение микрокредита',
				},
				{
					name: 'loan--application',
					image: require('@/assets/svg/icons/question_answers/icon_bell.svg'),
					text: 'Подача заявки',
				},
				{
					name: 'loan-decision',
					image: require('@/assets/svg/icons/question_answers/icon_check.svg'),
					text: 'Решение по микрокредиту',
				},
				{
					name: 'receiving-money',
					image: require('@/assets/svg/icons/question_answers/icon_cache.svg'),
					text: 'Получение денег',
				},
				{
					name: 'money-back',
					image: require('@/assets/svg/icons/question_answers/icon_tenge.svg'),
					text: 'Как вернуть деньги',
				},
				{
					name: 'repayment-loan',
					image: require('@/assets/svg/icons/question_answers/icon_lock.svg'),
					text: 'Возникли трудности <br/>с погашением микрокредита',
				},
				{
					name: 'personal-area',
					image: require('@/assets/svg/icons/question_answers/icon_man.svg'),
					text: 'Личный кабинет',
				},
			],
        }
	},
	computed: {
	},
	methods: {
		scroll: function (item) {
			if(this.isMobile){
				this.$scrollTo('.questions-answers__block--'+item.name, {offset:-50});
			}
		},
		//this.$router, this.$route, this.$store, this.$refs.test | this.$refs['test'], this.$http'
	},
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";

.questions-answers {
    display: inline-flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: flex-start;
    max-width: 1024px;
    width: 100%;
    margin: 0 auto;
    flex: 1;
    &__wrap {
        width: 100%;
        max-width: 240px;
        margin-bottom: 80px;
    }
    &__menu {
        width: 100%;
    }
    &__menu-list {

    }
    &__menu-item {
        position: relative;
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-start;

        width: 100%;
        min-height: 44px;
        list-style: none;
        text-decoration: none;

        &.router-link-active {
            background: $purple-site-o-2;
            .questions-answers__item-description {
                color: $purple-site;
            }
        }
        /*&.router-link-active:after {
            position: absolute;
            right: 5px;

            content: '';
            display: inline-block;
            width: 14px;
            height: 16px;
            background: url('~@/assets/svg/icons/question_answers/arrow_menu.svg') center/ contain no-repeat;
        }*/
    }
    &__menu-item:not(:last-child) {
        border-bottom: 1px solid $gray-mint;
    }
    &__item-icon {
        max-width: 22px;
        min-width: 22px;
        max-height: 23px;
        margin: 10px;
    }
    .icon--o-micro .questions-answers__item-icon {
        height: 18px;
    }
    &__item-description {
        color: $gray-dim-dark;
        font-family: $RobotoRegular;
        font-size: 14px;
        line-height: 18px;
        text-align: left;
    }
    &__content {
        display: inline-flex;
        flex-flow: column wrap;
        align-items: flex-start;
        justify-content: flex-start;

        max-width: 784px;
        width: 100%;
        padding: 0 0 80px 90px;
        box-sizing: border-box;
    }
    &__content-title {
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-start;

        margin-bottom: 19px;
    }
    &__content-icon {
        width: 136px;
        height: 125px;
        margin-right: 27px;
    }
    &__content-text {
        color: #93278F;
        text-align: left;
        font-family: $MontserratBold;
        font-size: 30px;
    }
}
@media screen and (max-width: 1024px) {
    .questions-answers {
        margin-top: 50px;

        &__wrap {
            width: 30%;
        }
        &__content {
            max-width: unset;
            width: 70%;
            padding: 0 10px 80px 15px;
        }
    }
}
@media screen and (max-width: 768px) {
    .questions-answers {
        flex-flow: column wrap;

        &__wrap {
            width: 100%;
            max-width: unset;
            margin-bottom: 30px;
        }
        &__content {
            width: 100%;
            max-width: unset;
            padding: 0 15px 80px;
        }
        &__item-description {
            margin-right: 15px;
            br {
                display: none;
            }
        }
    }
}
@media screen and (max-width: 500px) {
    .questions-answers {
        &__item-description {
            br {
                display: block;
            }
        }
    }
}
</style>
